import { render } from "./Timer.vue?vue&type=template&id=07e9c2bc&scoped=true&ts=true"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"

import "./Timer.vue?vue&type=style&index=0&id=07e9c2bc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e9c2bc"]])

export default __exports__